import { MDCDialog } from "@material/dialog";
import "lite-youtube-embed";
import "lite-youtube-embed/src/lite-yt-embed.css";

const siteWrap = document.querySelector(".site-wrap");
const dialog = new MDCDialog(document.querySelector(".mdc-dialog"));

dialog.root.removeAttribute("hidden");

let videoTriggers = document.querySelectorAll("button[data-modal-trigger]");

// Empty variable to set video id after click of play button
let currentVideoID;
// Resolves to the video's real "width / height" ratio string, falling back to 16:9
let currentVideoRatio;

videoTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    currentVideoID = trigger.getAttribute("data-videoid");
    // YouTube's oEmbed endpoint reports the video's real width/height so
    // square, portrait, etc. embeds aren't forced into a 16:9 box.
    currentVideoRatio = fetch(
      `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${currentVideoID}&format=json`
    )
      .then((response) => response.json())
      .then((data) => `${data.width} / ${data.height}`)
      .catch(() => "16 / 9");
    dialog.open();
  });
});

dialog.listen("MDCDialog:opened", function () {
  let ytTemplate = dialog.content.querySelector("template");

  // Clone template and insert parms to youtube player
  let ytPlayer = ytTemplate.content
    .cloneNode(true)
    .querySelector("lite-youtube");
  ytPlayer.setAttribute("videoid", currentVideoID);
  ytPlayer.setAttribute(
    "parmas",
    `mute=1&controls=0&${currentVideoID}&loop=1&modestbranding=2&rel=0&enablejsapi=1&playlist=${currentVideoID}`
  );
  currentVideoRatio.then((ratio) => {
    ytPlayer.style.setProperty("--video-ratio", ratio);
  });

  // Manually trigger play
  dialog.content.appendChild(ytPlayer);

  ytPlayer.querySelector("button").click();

  // Focus close button
  dialog.root.querySelector("button[data-mdc-dialog-initial-focus]").focus();

  // Hide content from screen reader while dialog is open
  siteWrap.setAttribute("aria-hidden", "true");
});

dialog.listen("MDCDialog:closing", function () {
  // Un-hide content from screen reader
  siteWrap.removeAttribute("aria-hidden");
});

dialog.listen("MDCDialog:closed", function () {
  let liteYt = dialog.content.querySelector("lite-youtube");
  liteYt.remove();
});
